import React, { useEffect, useState } from 'react';
import { Redirect } from "react-router-dom";
import { range } from '../../helper';
import { useCoverLetter } from '../../context/CoverLetterContext';
import {
  COOKIE_DOMAIN,
  COVERLETTER_BUILD,
  COVERLETTER_CHOOSE_TEMPLATE,
  COVERLETTER_CUSTOMIZE,
  COVERLETTER_EXPERIENCE,
  COVERLETTER_SKILLS,
  DASHBOARD_LINK,
  HOME_URL
} from '../../constants/constants';
import '../../assets/scss/app/cover-letter-screens/on-bording-screens.scss';
import ExperienceForm from './QuesAnsSections/ExperienceForm';
import jsCookie from 'js-cookie';
import { initiateCoverLetterQA } from '../../services/actions/actions';
import { useDispatch } from 'react-redux';

const Experience = (props) => {
  const dispatch = useDispatch();
  // const history = useHistory()
  const [back, setBack] = useState(false);
  const [next, setNext] = useState(false);
  const [redirect2, setRedirect2] = useState(null);
  const [userExperience, setUserExperience] = useState(null);
  //   const { 
  //     otherdetails,
  //     enabled_tabs
  //   ,
  //   handlers: {
  //       save,
  //       update2Preview,
  //   },
  // } = useCoverLetter();

  // const  saveForm = (data) => {
  //   const aiRequestData = { ...otherdetails.ques_ans_response, ...data };
  //   update2Preview({ otherdetails: { ...otherdetails, ques_ans_response: aiRequestData } });
  // }


  // useEffect(() => {
  //   setUserExperience(otherdetails.ques_ans_response.experience)
  // }, [otherdetails])
  useEffect(() => {
        //browser issue, page not opening at top
        window.scrollTo(0, 0)


  }, []);
  useEffect(() => {
    const req4rm = localStorage.getItem('cl_builder')
    if (next) {
      if (req4rm) {
        //if templat data is saveded save and move directly to first landing page
        const color = localStorage.getItem('cl_color')
        const tpl = localStorage.getItem('cl_tpl')
        const customColor = localStorage.getItem('cl_custom_color');
        //Create CL
        jsCookie.remove('current_letter', { domain: COOKIE_DOMAIN, path: "/" });
        dispatch(initiateCoverLetterQA(customColor, color, tpl, userExperience))
        setRedirect2(COVERLETTER_CUSTOMIZE)
        //Clean local storage otherwise it might create problem with other workflow

      } else setRedirect2(`${COVERLETTER_CHOOSE_TEMPLATE}${userExperience ?? ''}`)
    }
    (back || next) && history.pushState(null, COVERLETTER_EXPERIENCE);
    // back && setRedirect2(req4rm ? COVERLETTER_BUILD : COVERLETTER_CHOOSE_TEMPLATE)
  }, [back, next]);

  //set dashboard_tab when user comes from the main site or uses the direct URL
  useEffect(() => {
    jsCookie.set('dashboard_tab', 'coverletter', {domain: COOKIE_DOMAIN, path: "/"});
  }, []);

  if (redirect2) return <Redirect to={redirect2} />

  return (
  <div className="cover-screen-outer">
    <div className="screen-inner">
      <div className="block">
        <div className="screen screen-three">
          <h1>How many relevant years of experience do you have?</h1>
          <p>Relevant experience can include jobs, freelance contracts, internships, and volunteering.</p>
          <ExperienceForm data={{experience: userExperience}} save={(data) => setUserExperience(data?.experience)} />
          <div className="screen-action">
            {/* <button className="round-btn" onClick={() => setBack(!back)}> <i className="arrow-bar-left"></i><span>Back</span></button> */}
            <button className="round-btn  active" onClick={() => setNext(!next)}><span>Next</span><i className="arrow-bar-right"></i></button>
            <small className="experience-disclaimer-text">By continuing, you agree to our <a href={`${HOME_URL}/terms-and-conditions/`} target="_blank"> Terms of Service </a> and <a href={`${HOME_URL}/privacy-policy/`}  target="_blank">Privacy Policy</a>.</small>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
}

export default Experience;